/** Dependencies **/
import moment from 'moment';

/** Components **/
import TableCellEventType from './../../../components/Table/TableCells/EventType';

export const EventEndDateColumn = widthColumns => 
{
  return {
    accessor: "endDate",
    width: widthColumns['endDate'],
    title: "date",
    className: "col-label",
    disableSortBy: true,
    disableFilters: true,
    Header: props => "date",
    Cell: props => 
      <TableCellEventType 
        {...props.row.getToggleRowSelectedProps()} 
        label={ props.value !== null && props.value !== undefined ? moment( props.value.toString() ).format( 'DD/MM/YYYY' ) : null }
      />
  }
} 